import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = {
  key: 0,
  class: "d-flex flex-row"
}
const _hoisted_3 = {
  class: "ds-text-regular mt-2 mb-2",
  style: {"width":"500px"}
}
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("h2", null, "License List Excel", -1)),
    (_ctx.licenseListAllowed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_button, {
                disabled: _ctx.downloadingLicenses,
                title: "Download all licenses as xlsx-file",
                id: "test-id-download-licenses",
                type: "primary",
                class: "mt-5",
                loading: _ctx.downloadingLicenses,
                onClick: _ctx.getAllLicenses
              }, {
                default: _withCtx(() => _cache[0] || (_cache[0] = [
                  _createTextVNode(" DOWNLOAD LICENSES ", -1)
                ])),
                _: 1,
                __: [0]
              }, 8, ["disabled", "loading", "onClick"])
            ])
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "ds-text-regular mt-2 mb-2 pr-5 pl-5",
            style: {"width":"600px"}
          }, [
            _createElementVNode("h2", null, "Instructions"),
            _createElementVNode("p", null, [
              _createTextVNode(" Click "),
              _createElementVNode("i", null, "DOWNLOAD LICENSES"),
              _createTextVNode(" button to download an xlsx-file with all generated licenses and their information. ")
            ])
          ], -1))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[2] || (_cache[2] = [
          _createElementVNode("p", null, "You do not have access rights to license list.", -1)
        ])))
  ]))
}